import { render, staticRenderFns } from "./ReportDetailForm.vue?vue&type=template&id=13556924&"
import script from "./ReportDetailForm.vue?vue&type=script&lang=ts&"
export * from "./ReportDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDetailForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports